import React from "react"
import "./user.css"
import { Col } from "react-bootstrap"

const SighnUp = () =>{
    return(
        <Col sm={6}>
            <h1>
                Hello SighnUp
            </h1>
        </Col>
    )
}

export default SighnUp